<template>
  <div>
    <franquia v-if="franquiasEnabled"/>
    <home-app v-else/>
  </div>
</template>

<script>
  import HomeApp from "./HomeApp";
  import Franquia from "./Franquia";
  export default {
    name: 'Home',
    components: {Franquia, HomeApp},
    mounted() {
    }
  }
</script>

<style scoped>

</style>
